import React from 'react';
import { useTranslation } from 'react-i18next';
import SubMenuGroup from '../SubMenuGroup';
import SubMenuGroupRecommend from '../SubMenuGroupRecommend';
import DefaultMenuGroupRecommend from '../DefaultMenuGroupRecommend';
import { useStyles } from './styles';

const ProductsList = ({
  sectionMenu,
  name,
  topBannerRef,
  defaultRecommendProduct,
  subMenuRecommendProduct,
  setSubMenuCoordsList,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('menu');

  return (
    <div className={classes.cocktailList}>
      {sectionMenu.length === 0 && (
        <p className={classes.noProductsMessage}>{t('noProducts')}</p>
      )}

      {defaultRecommendProduct && (
        <DefaultMenuGroupRecommend
          key={defaultRecommendProduct.name}
          section={defaultRecommendProduct}
          topBannerText={defaultRecommendProduct.recommendationBanner}
          topBannerRef={topBannerRef}
        />
      )}

      {subMenuRecommendProduct && (
        <SubMenuGroupRecommend
          key={subMenuRecommendProduct.name}
          section={subMenuRecommendProduct}
          setSubMenuCoordsList={setSubMenuCoordsList}
          topBannerText={subMenuRecommendProduct.recommendationBanner}
        />
      )}
      <SubMenuGroup section={sectionMenu} name={name} />
    </div>
  );
};

export default ProductsList;
